import React, { useState } from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { summarizePriceChange } from "../../utils/subscriptionPriceChanges";

function PriceChangeList({ changes, locale }) {
  return (
    <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none" }}>
      {changes.map((change) => {
        const summary = summarizePriceChange(change, locale);
        return (
          <Box component="li" key={summary.key} sx={{ py: 0.5 }}>
            <Typography variant="caption" display="block" sx={{ fontWeight: 600 }}>
              {summary.date}
              {summary.automatic ? " · automatic" : ""}
            </Typography>
            <Typography variant="caption" display="block">
              {summary.oldAmount} → {summary.newAmount}
              {summary.interval ? ` / ${summary.interval}` : ""}
            </Typography>
            <Typography variant="caption" display="block">
              {summary.difference} ({summary.percent})
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

// Opens on hover or keyboard focus, closes on leave, blur or Escape.
const PriceUpdatedBadge = ({ changes, locale }) => {
  const [hovering, setHovering] = useState(false);
  const [focused, setFocused] = useState(false);
  if (!Array.isArray(changes) || changes.length === 0) return null;

  const close = () => {
    setHovering(false);
    setFocused(false);
  };

  return (
    <Tooltip
      title={<PriceChangeList changes={changes} locale={locale} />}
      open={hovering || focused}
      describeChild
      disableHoverListener
      disableFocusListener
      disableTouchListener
      componentsProps={{ tooltip: { sx: { maxWidth: 280 } } }}
    >
      <Chip
        label="Price updated"
        size="small"
        color="info"
        variant="outlined"
        tabIndex={0}
        data-testid="price-updated-badge"
        sx={{ mt: 0.5 }}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        // Lists open a row on click; reading the badge should not navigate.
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => {
          if (event.key === "Escape") close();
        }}
      />
    </Tooltip>
  );
};

export default PriceUpdatedBadge;
